<template>
  <backbar-page-layout
    back-title="title.user_details"
    :title="title"
    :user-id="id"
    :loading="isLoadingStatus"
  >
    <b-bsq-modal
      ref="modal"
      v-model="isModalEnabled"
      :header-title="modalHeaderTitle"
      :button-title="modalButtonTitle"
      :button-variant="modalButtonVariant"
      @ok="modalSubmit"
    >
      <div class="mt-3 mb-5">
        <div v-if="isLogoutDeviceModalEnabled">
          <div class="mb-3">
            {{ $t('description.log_out_device') }}
          </div>
          <i18n path="description.last_active" tag="div" class="mb-3">
            <span place="date">{{ logoutSession.lastSeenAt }}</span>
          </i18n>
          <div>
            {{ logoutSession.userAgent }}
          </div>
        </div>
      </div>
    </b-bsq-modal>
    <b-container>
      <b-row class="text-right">
        <b-col>
          <b-button
            v-b-tooltip.hover
            :title="$t('description.work_in_progress')"
            variant="outline-danger"
          >
            {{ $t('button.log_out_all') }}
          </b-button>
        </b-col>
      </b-row>
      <b-table
        class="theme-general"
        cellspacing="0"
        :items="sessions"
        :fields="fields"
      >
        <template v-slot:cell(id)="data">
          <with-loading-content :loading="loading">
            {{ data.value }}
          </with-loading-content>
        </template>
        <template v-slot:cell(lastSeenAt)="data">
          <with-loading-content :loading="loading">
            {{ data.value }}
          </with-loading-content>
        </template>
        <template v-slot:cell(userAgent)="data">
          <with-loading-content :loading="loading">
            {{ data.value }}
          </with-loading-content>
        </template>
        <template v-slot:cell(actions)="data">
          <with-loading-content :loading="loading">
            <b-button
              variant="danger"
              @click="setLogoutItem(data.item.id)"
            >
              {{ $t('button.log_out') }}
            </b-button>
          </with-loading-content>
        </template>
      </b-table>
      <b-row align-v="center">
        <b-col cols="6">
          <i18n path="description.total_items" tag="div" class="ml-4">
            <span place="number">{{ totalItems }}</span>
          </i18n>
        </b-col>
        <b-col cols="6" class="text-right">
          <pagination
            class="mr-4"
            button-class="btn-custom"
            :previous-page-token="prevPageToken"
            :next-page-token="nextPageToken"
            @previous-click="previousPage"
            @next-click="nextPage"
          />
        </b-col>
      </b-row>
    </b-container>
  </backbar-page-layout>
</template>

<script>
import { mapState } from 'vuex'

import BackbarPageLayout from '@/components/BackbarPageLayout.vue'
import WithLoadingContent from '@/components/WithLoadingContent.vue'
import Pagination from '@/components/Pagination.vue'

import store from '@/store'
import router from '@/router'
import i18n from '@/i18n'

export default {
  name: 'UserDetailsDevices',
  components: {
    BackbarPageLayout,
    WithLoadingContent,
    Pagination
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    pageToken: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'userAgent', label: i18n.t('table_header.user_agent'), thClass: 'w-25' },
        { key: 'lastSeenAt', label: i18n.t('table_header.last_active') },
        { key: 'actions', label: i18n.t('table_header.log_out_device') }
      ],

      isLogoutDeviceModalEnabled: false,
      logoutSession: undefined
    }
  },

  computed: {
    ...mapState('client', [
      'authenticated'
    ]),
    ...mapState('management/userDetails', [
      'user'
    ]),
    ...mapState('management/userDetails/devicesList', [
      'sessions',
      'prevPageToken',
      'nextPageToken',
      'totalItems',

      'loading'
    ]),
    isLoadingStatus () {
      return !this.authenticated || this.loading
    },
    title () {
      return 'title.devices'
    },
    isModalEnabled: {
      get () {
        return this.isLogoutDeviceModalEnabled
      },
      set () {
        setTimeout(() => {
          this.isLogoutDeviceModalEnabled = false
        }, 500)
      }
    },
    modalHeaderTitle () {
      if (this.isLogoutDeviceModalEnabled) {
        return i18n.t('actions.log_out_device')
      }
      return ''
    },
    modalButtonTitle () {
      if (this.isLogoutDeviceModalEnabled) {
        return i18n.t('actions.log_out')
      }
      return ''
    },
    modalButtonVariant () {
      if (this.isLogoutDeviceModalEnabled) {
        return 'danger'
      }
      return ''
    }
  },

  watch: {
    async user (newVal) {
      if (newVal !== undefined) {
        await store.dispatch('management/userDetails/devicesList/list', {
          pageToken: this.pageToken,
          ascending: false
        })
      }
    }
  },

  created () {},
  mounted () {},
  updated () {},
  destroyed () {},

  methods: {
    async modalSubmit () {
      if (this.isLogoutDeviceModalEnabled) {
        await this.logoutDevice()
      }
      this.$nextTick(() => {
        this.isLogoutDeviceModalEnabled = false
      })
    },
    async logoutDevice () {
      await store.dispatch('management/userDetails/devicesList/delete', this.logoutSession.id)
    },
    setLogoutItem (id) {
      this.isLogoutDeviceModalEnabled = !this.isLogoutDeviceModalEnabled
      this.logoutSession = this.sessions.find(item => item.id === id)
    },
    previousPage () {
      router.replace({ name: 'UserDetailsDevices', query: { pageToken: this.prevPageToken } })
    },
    nextPage () {
      router.replace({ name: 'UserDetailsDevices', query: { pageToken: this.nextPageToken } })
    }
  },

  beforeRouteUpdate (to, from, next) {
    store.dispatch('management/userDetails/devicesList/list', {
      pageToken: to.query.pageToken,
      ascending: false
    })
    next()
  }
}
</script>
